import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { AppShell } from '@/components/shared/AppShell';
import { meOptions } from '@/features/auth/api';
import { projectsListOptions } from '@/features/projects/api';
import { ProfileHeader } from '@/features/profile/components/ProfileHeader';
import { AccountSection } from '@/features/profile/components/AccountSection';
import { AppearanceSection } from '@/features/profile/components/AppearanceSection';
import { ProjectsList } from '@/features/profile/components/ProjectsList';
import { SignOutButton } from '@/features/profile/components/SignOutButton';

export const Route = createFileRoute('/_authed/profile')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(meOptions()),
      context.queryClient.ensureQueryData(projectsListOptions()),
    ]),
  component: ProfilePage,
});

function ProfilePage() {
  const { data: me } = useSuspenseQuery(meOptions());
  const { data: projects } = useSuspenseQuery(projectsListOptions());

  return (
    <AppShell currentUser={{ id: me.id, displayName: me.display_name, email: me.email }}>
      <div className="mx-auto max-w-3xl px-6 py-10">
        <div className="space-y-10">
          <ProfileHeader
            user={{ id: me.id, displayName: me.display_name, email: me.email }}
          />

          <AccountSection me={me} />

          <AppearanceSection />

          <ProjectsList userId={me.id} projects={projects} />

          <div className="flex justify-end border-t border-border pt-6">
            <SignOutButton />
          </div>
        </div>
      </div>
    </AppShell>
  );
}
